import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/user-list',
      name: 'admin-user-list',
      component: () => import(/* webpackChunkName: "page-admin-system-management-user-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "员工管理"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "系统管理"
                                        },
                                        {
                                                  name: "员工管理"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
